// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/warning-notification/stylesheet/style.scss
 ** module id = 440
 ** module chunks = 1
 **/